var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C5.34314 2 4 3.34315 4 5V5.25H20V5C20 3.34315 18.6569 2 17 2H7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.75H4V11.25H11.25V6.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.25V6.75H20V11.25H12.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 12.75V17C4.00004 17.7881 4.4559 18.4698 5.11832 18.7957L3.36404 21.6025C3.14451 21.9538 3.25129 22.4165 3.60254 22.636C3.95379 22.8555 4.4165 22.7488 4.63604 22.3975L6.75947 19H17.2406L19.364 22.3975C19.5835 22.7488 20.0463 22.8555 20.3975 22.636C20.7488 22.4165 20.8555 21.9538 20.636 21.6025L18.8817 18.7957C19.5442 18.4698 20 17.7881 20 17V12.75H4.00004ZM5.25003 16C5.25003 15.5858 5.58582 15.25 6.00003 15.25H9.00003C9.41424 15.25 9.75003 15.5858 9.75003 16C9.75003 16.4142 9.41424 16.75 9.00003 16.75H6.00003C5.58582 16.75 5.25003 16.4142 5.25003 16ZM15 15.25H18C18.4142 15.25 18.75 15.5858 18.75 16C18.75 16.4142 18.4142 16.75 18 16.75H15C14.5858 16.75 14.25 16.4142 14.25 16C14.25 15.5858 14.5858 15.25 15 15.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainAlt);
export default __webpack_public_path__ + "static/media/train-alt.b954b7932ac1ed8dce6ee934f6b85f20.svg";
export { ForwardRef as ReactComponent };